/* ======================  SCRIPTS ====================== */

    $(window).on('load', documentReady);

    function documentReady() {

        /* init margin banner */
        bannerMargin();

        $(".product-list").owlCarousel({
            items: 1,
            dots: true,
            loop: false,
            margin: 20,
            mouseDrag: false,
            nav: false,
            navText: [],
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive:{
                680:{
                    items: 3,
                    autoplay: false,
                },
                1024:{
                    items: 3,
                    autoplay: false,
                },
                1280:{
                    items: 4,
                    autoplay: false,
                }
            }
        });

        $(".brand-list").owlCarousel({
            items: 1,
            dots: true,
            loop: true,
            margin: 20,
            mouseDrag: false,
            nav: false,
            navText: [],
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive:{
                680:{
                    items: 3,
                    margin: 30,
                    nav: true,
                    loop: false,
                },
                1024:{
                    items: 3,
                    margin: 30,
                    nav: true,
                    loop: false,
                },
                1280:{
                    items: 6,
                    margin: 30,
                    nav: true,
                    loop: false,
                }
            }
        });
        $(".new-list").owlCarousel({
            items: 1,
            stagePadding: 40,
            dots: true,
            loop: false,
            margin: 20,
            mouseDrag: false,
            navText: [],
            responsive:{
                680:{
                    items: 3,
                    stagePadding: 0,
                },
                1024:{
                    items: 3,
                    stagePadding: 0,
                },
                1280:{
                    items: 3,
                    stagePadding: 0,
                }
            }
        });

        $(".element-list").owlCarousel({
            items: 1,
            dots: true,
            loop: false,
            margin: 0,
            mouseDrag: false,
            nav: false,
            navText: [],
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive:{
                680:{
                    items: 3,
                    autoplay: false,
                    margin: 20,
                },
                1024:{
                    items: 3,
                    autoplay: false,
                    margin: 20,
                },
                1280:{
                    items: 3,
                    autoplay: false,
                    margin: 20,
                }
            }
        });

        function bannerMargin() {
            var marginTopBanner = $(".navbar-fixed-top").innerHeight();
            var marginTopBannerFixed = marginTopBanner;

            marginTopBanner = marginTopBanner + 60;

            $(".banner").attr('style', 'margin-top:' + marginTopBanner + 'px !important; ');
            $(".gm-full-banner").attr('style', 'margin-top:' + marginTopBannerFixed + 'px !important; ');
        }

        $(window).resize(function() {
            bannerMargin();
        });

        $(".internal-nav ul li a[href^='#']").on('click', function(e) {
            $(".internal-nav ul li a").removeClass("internal-nav-active");

            $(this).addClass("internal-nav-active");
            e.preventDefault();

            var hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top - 200
            }, 500, function(){

                window.location.hash = hash;
            });


        });

    }


